export const cmsPages = (state) => state.cmsPages

export const getCmsPageById = (state) => (slogId) => state.cmsPages[slogId]

export const loading = (state) => state.loading
